
import {Options, Vue} from 'vue-class-component';
import './../less/elements/accordion.less'

@Options({
    props: {
        accordion: {title: String, description: String}
    }
})
@Options({
    components: {},
})
export default class Accordion extends Vue {
    isAccordionOpen = false

    accordionToggle() {
        this.isAccordionOpen = !this.isAccordionOpen
    }
}
